module.exports = __webpack_public_path__ + "media/gop-video.057a2a91.mp4";